var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
    }
    HomeComponent.prototype.ngOnInit = function () {
        var that = this;
        // $("#btnMainConfirm").off('click');
        // $("#btnMainConfirm").click(async function () {
        //   await that.Save();
        // });
        // this.BeforeSearch();
    };
    HomeComponent.prototype.BeforeSearch = function () {
        this.util.ShowWaiting(true);
        this.Search();
    };
    HomeComponent.prototype.Search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res, obj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        return [4 /*yield*/, this.apiService.post('Chart', 'GetDataHome', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                obj = res.responseData;
                                $('#lblS').html(obj.curr_data.sum_all);
                                $('#lblR').html(obj.curr_data.sum_r);
                                $('#lblB').html(obj.curr_data.sum_b);
                                $('#lblV').html(obj.curr_data.sum_v_curr);
                                $('#lblGarantor').html('Garantor letter as of ' + obj.garantor_date);
                                InitChartHome(obj);
                                if (obj.sum_w > 0) {
                                    $('#lblNumber').html('รายการรอทำจดหมายส่งสอบจำนวน ' + obj.sum_w + ' รายการ กรุณาตรวจสอบ');
                                    $('#dlgNoti').modal();
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeComponent.prototype.ConfirmUpdate = function () {
        this.util.ConfirmDialog('Update ข้อมูล');
    };
    HomeComponent.prototype.Save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        data = {};
                        that.util.ShowWaiting(true);
                        return [4 /*yield*/, this.apiService.post('chart', 'UpdateDashBoardReport', data, null)];
                    case 1:
                        res = _a.sent();
                        that.util.ShowWaiting(false);
                        if (res != null) {
                            if (res.isSuccess) {
                                this.util.SuccessDialog('Update ข้อมูลสำเร็จ');
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            this.util.ErrorDialog('System Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return HomeComponent;
}());
export { HomeComponent };



// WEBPACK FOOTER //
// ./src/app/home/home/home.component.ts.pre-build-optimizer.js